<template>
  <v-card class="rounded-lg flex d-flex flex-column">
    <v-card-text>
      <v-row>
        <v-col>
          <span class="font-weight-bold text-body-1 font-italic">
            Detalle de lote en producción
          </span>
        </v-col>
      </v-row>
      <div v-if="loteSelected">
        <v-row class="pb-0">
          <v-col class="pb-0">
            <span class="text-subtitle-1"
              >Lote - {{ loteSelected.loteId }}</span
            >
          </v-col>
        </v-row>
        <v-row class="text-end py-0">
          <v-col class="py-0">
            <span
              class="font-weight-bold text-body-2"
              v-if="loteSelected.productLine == 'H'"
            >
              Linea de Hongo</span
            >
            <span
              class="font-weight-bold text-body-2"
              v-else-if="loteSelected.productLine == 'B'"
            >
              Linea de Bacteria</span
            >
            <span
              class="font-weight-bold text-body-2"
              v-else-if="loteSelected.productLine == 'AS'"
            >
              Linea de Actinomicetos</span
            >
            <span
              class="font-weight-bold text-body-2"
              v-else-if="loteSelected.productLine == 'F'"
            >
              Linea de biofertilizate</span
            >
            <span class="font-weight-bold text-body-2" v-else>
              Linea no especificada</span
            >
          </v-col>
        </v-row>
        <v-row class="py-0">
          <v-col class="py-0" v-if="loteSelected.loteType == 'SINGLE'">
            <span
              class="text-body-2"
              v-if="
                loteSelected.identificationCode &&
                loteSelected.identificationCode.length > 0
              "
            >
              {{ loteSelected.identificationName }}
              ({{ loteSelected.identificationCode }})
            </span>
            <span class="text-body-2" v-else>
              {{ loteSelected.identificationName }}
            </span>
          </v-col>
          <v-col class="py-0" v-if="loteSelected.loteType == 'BIO'">
            <span class="text-body-2"> Ag Boost (01) </span>
          </v-col>
        </v-row>
        <v-row class="py-0 align-center">
          <v-col cols="7">
            <span class="text-body-2">
              Dósis: {{ loteSelected.dosesEnd }} pzas
            </span>
          </v-col>
          <v-col
            cols="4"
            class="offset-1"
            v-if="loteSelected.orders && loteSelected.orders.length > 0"
          >
            <v-btn block rounded color="primary" small> Ver OPs </v-btn>
          </v-col>
        </v-row>
        <v-row class="align-center text-center" justify="center">
          <v-col cols="7">
            <div
              v-if="loteSelected.productionState == 'SIFTING'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Molido/Tamizado </span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'DRYING'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Secado </span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'INCUBATING'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Incubación </span>
            </div>
            <div
              v-else-if="loteSelected.productionState == '1_VALIDATION'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> 1ra validación </span>
            </div>
            <div
              v-else-if="loteSelected.productionState == '2_VALIDATION'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> 2da validación </span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'STOCK'"
              class="text-caption pa-2 rounded-lg stockSpore"
            >
              <span> Stock de espora </span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'STOCK_PT'"
              class="text-caption pa-2 rounded-lg stockSpore"
            >
              <span> Almacén PT </span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'PREINOCULATE'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Preinóculo</span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'CONTAMINATED'"
              class="text-caption pa-2 rounded-lg decrease"
            >
              <span> Contaminado</span>
            </div>
            <div v-if="loteSelected.productionState == 'CONTAMINATED'">
              <span
                class="red--text"
                v-if="loteSelected.reasonContamination == 'bacteria'"
                >(Eliminada por bacterias)</span
              >
              <span
                class="red--text"
                v-if="loteSelected.reasonContamination == 'fungi'"
                >(Eliminada por hongos)</span
              >
            </div>
            <div
              v-else-if="loteSelected.productionState == 'USELESS'"
              class="text-caption pa-2 rounded-lg decrease"
            >
              <span>Lote desechado</span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'DISCARDED'"
              class="text-caption pa-2 rounded-lg decrease"
            >
              <span>Lote desechado</span>
            </div>
            <div
              v-else-if="loteSelected.productionState == 'INOCULATE'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span>inóculo</span>
            </div>

            <div
              v-if="loteSelected.productionState == 'GRINDING'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Molienda</span>
            </div>
            <div
              v-if="loteSelected.productionState == 'FERMENTATION'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Fermentación</span>
            </div>
            <div
              v-if="loteSelected.productionState == 'DIGESTION'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Digestión</span>
            </div>
            <div
              v-if="loteSelected.productionState == 'FORMULATION'"
              class="text-caption pa-2 rounded-lg finish"
            >
              <span> Formulación/Envasado</span>
            </div>
            <div
              v-if="loteSelected.productionState == 'SEED'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span>Semilla</span>
            </div>
            <div
              v-if="loteSelected.productionState == 'FEEDABLE'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Realimentación </span>
            </div>
            <div
              v-if="loteSelected.productionState == 'BATCH_CREATED'"
              class="text-caption pa-2 rounded-lg finish"
            >
              <span> Lote creado </span>
            </div>
            <div
              v-if="loteSelected.productionState == 'FLASK_VALIDATED'"
              class="text-caption pa-2 rounded-lg comonstate"
            >
              <span> Matraces validados </span>
            </div>
          </v-col>
          <v-col>
            <span class="text-body-2">
              Hace
              <span class="font-weight-bold">{{
                elapsedTime(loteSelected.createdAt)
              }}</span>
              en producción
            </span>
          </v-col>
        </v-row>
        <v-row
          v-if="
            loteSelected.alarmValidation1 ||
            loteSelected.alarmInoculate ||
            loteSelected.alarmValidation2 ||
            loteSelected.alarmRice
          "
        >
          <v-col>
            <span
              v-if="loteSelected.alarmValidation1"
              class="text-caption pa-2 rounded-lg decrease"
            >
              Validación 1 pendiente
            </span>
            <span
              v-else-if="loteSelected.alarmInoculate"
              class="text-caption pa-2 rounded-lg decrease"
            >
              Pendiente de pasar a 2 validación
            </span>
            <span
              v-else-if="loteSelected.alarmValidation2"
              class="text-caption pa-2 rounded-lg decrease"
            >
              Validación 2 pendiente
            </span>
            <span
              v-else-if="loteSelected.alarmRice"
              class="text-caption pa-2 rounded-lg decrease"
            >
              Pendiente de ir al arroz
            </span>
          </v-col>
        </v-row>
        <v-row no-gutters class="align-center mt-4">
          <v-col cols="1" class="text-center">
            <v-icon> mdi-plus-circle </v-icon>
            <v-spacer></v-spacer>
            <span>Inicio</span>
          </v-col>
          <v-col>
            <v-progress-linear value="0"></v-progress-linear>
          </v-col>
          <v-col cols="1" class="text-center">
            <v-icon> mdi-package-variant-closed </v-icon>
            <v-spacer></v-spacer>
            <span>Fin</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            v-if="
              this.loteSelected &&
              this.loteSelected.productionState !== 'CONTAMINATED' &&
              this.loteSelected.productionState !== 'USELESS'
            "
          >
            <v-row>
              <!-- v-if="user.role == 'PRODUCTION'" -->
              <v-col cols="12">
                <v-btn
                  color="gray"
                  dark
                  class="rounded-lg"
                  elevation="10"
                  block
                  @click="openUpdateLoteModal()"
                  >Actualizar lote Producción</v-btn
                >
              </v-col>
              <!-- v-if="user.role == 'QUALITY'" -->
              <v-col cols="12">
                <v-btn
                  color="gray"
                  dark
                  class="rounded-lg"
                  elevation="10"
                  block
                  @click="openUpdateLoteModalQ()"
                  >Actualizar lote Calidad</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-data-table
              fixed-header
              height="450px"
              :headers="headers"
              :items="productionLogs"
              :items-per-page="10"
              no-data-text="No hay actividad en el lote"
              loading-text="Cargando eventos de lote..."
              :page.sync="page"
              hide-default-footer
              :loading="fetchingData"
            >
              <template #[`item.logProductionType`]="{ item }">
                <span
                  class="text-body-2"
                  v-if="item.logProductionType == 'CREATED'"
                >
                  LOTE CREADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == '1_VALIDATION_SAVE'"
                >
                  GUARDADO EN VALIDACIÓN 1
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == '1_VALIDATION_END'"
                >
                  VALIDACIÓN 1 TERMINADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == '2_VALIDATION'"
                >
                  INICIO VALIDACIÓN 2
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == '2_VALIDATION_SAVE'"
                >
                  GUARDADO EN VALIDACIÓN 2
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == '2_VALIDATION_END'"
                >
                  VALIDACIÓN 2 TERMINADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'START_INCUBATING'"
                >
                  INICIO DE INCUBACIÓN
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'INCUBATING_SAVE'"
                >
                  GUARDADO EN INCUBACIÓN
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'INCUBATING_SAVE_QUALITY'
                  "
                >
                  GUARDADO EN INCUBACIÓN CALIDAD
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'BAG_WASTE'"
                >
                  REGISTRO DE MERMA EN ARROZ
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'END_INCUBATING'"
                >
                  TERMINO DE INCUBACIÓN
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'START_DRY'"
                >
                  INICIO DE SECADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'END_DRY'"
                >
                  FIN DE SECADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SPLIT'"
                >
                  DIVISION DE LOTE
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'START_SIFTING'"
                >
                  INICIO MOLIDO/TAMIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SAVE_SIFTING'"
                >
                  GUARDADO EN MOLIDO/TAMIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'END_SIFTING'"
                >
                  TERMINO MOLIDO/TAMIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'CONTAMINATED'"
                >
                  LOTE CONTAMINADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'CONTROL_VALIDATION_FINISH'
                  "
                >
                  VALIADACIÓN EN ARROZ FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SAVE_GRINDING'"
                >
                  MOLIDO GUARDADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'END_GRINDING'"
                >
                  MOLIDO FINALIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'START_FERMENTATION'"
                >
                  FERMENTACIÓN INICIADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SAVE_FERMENTATION'"
                >
                  FERMENTACIÓN GUARDADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'END_FERMENTATION'"
                >
                  FERMENTACIÓN FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'START_DIGESTION'"
                >
                  DIGESTION INICIADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SAVE_DIGESTION'"
                >
                  DIGESTION GUARDADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'END_DIGESTION'"
                >
                  DIGESTION FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'START_FORMULATION'"
                >
                  FORMULADO/ENVASADO INICIADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'ADD_FORMULATION'"
                >
                  FORMULADO AÑADIDO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'ADD_PACKING'"
                >
                  ENVASADO AÑADIDO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'USELESS'"
                >
                  LOTE DESECHADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'DISCARDED'"
                >
                  LOTE DESECHADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'CEPARIO_VALIDATION_SAVE'
                  "
                >
                  VALIDACIÓN CEPARIO GUARDADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'CEPARIO_VALIDATION_FINISH'
                  "
                >
                  VALIDACIÓN CEPARIO FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'PREINOCULATE_SAVE'"
                >
                  PREINÓCULO GUARDADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'PREINOCULATE_SAVE_VALIDATION'
                  "
                >
                  VALIDACIÓN PREINÓCULO GUARDADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'PREINOCULATE_FINISH'"
                >
                  PREINÓCULO FINALIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'INOCULATE_START'"
                >
                  INÓCULO INICIADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'INOCULATE_END'"
                >
                  INÓCULO FINALIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SEED_START'"
                >
                  SEMILLA INICIADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SEED_SAVE'"
                >
                  SEMILLA GUARDADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SEED_END_VALIDATION'"
                >
                  SEMILLA VALIDACIÓN FINALIZADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SEED_SAVE_LAST'"
                >
                  SEMILLA GUARDADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SEED_END'"
                >
                  SEMILLA FINALIZADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'FERMENTATION_SAVE'"
                >
                  FEMENTACIÓN GUARDADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'FERMENTATION_END'"
                >
                  FEMENTACIÓN FINALIZADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'FERMENTATION_END_VALIDATION_3L'
                  "
                >
                  FEMENTACIÓN VALIDACIÓN 3L FINALIZADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'FERMENTATION_REFEEDABLE'
                  "
                >
                  REALIMENTACIÓN AGREGADA
                </span>

                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'INOCULATE_SAVE'"
                >
                  INOCULACIÓN GUARDADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'DRUMS_REGISTER_END'"
                >
                  REGISTRO DE BIDONES FINALIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'DRUMS_REGISTER_SAVE'"
                >
                  REGISTRO DE BIDONES GUARDADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SEED_FEEDABLE_START'"
                >
                  REALIMENTACIÓN BB13 INICIADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'SEED_FEEDABLE_SAVE'"
                >
                  REALIMENTACIÓN BB13 GUARDADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'SEED_FEEDABLE_END_VALIDATION'
                  "
                >
                  REALIMENTACIÓN BB13 FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'QPCR_VALIDATION_SAVE'"
                >
                  VALIDACIÓN QPCR GURADADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'QPCR_VALIDATION_END'"
                >
                  VALIDACIÓN QPCR FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'UPDATE_PLATE_HISTORY'"
                >
                  CONCENTRACIÓN ACTUALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'MR_SAVE'"
                >
                  MR GUARDADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'MR_VALIDATION_END'"
                >
                  MR VALIDACIÓN FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'MR_END'"
                >
                  MR FINALIZADO
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'ESTERILIZATION_QUANTITY_SAVE'
                  "
                >
                  ESTERILIZACIÓN CALIDAD GUARDADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'VALIDATION_END_TIME_SAVE'
                  "
                >
                  DATOS VALIDACIÓN TIEMPO FINAL GUARDADOS
                </span>
                <span
                  class="text-body-2"
                  v-else-if="
                    item.logProductionType == 'VALIDATION_END_TIME_END'
                  "
                >
                  VALIDACIÓN TIEMPO FINAL FINALIZADA
                </span>
                <span
                  class="text-body-2"
                  v-else-if="item.logProductionType == 'MR_SAVE_PH'"
                >
                  PH INICIAL EN MR GUARDADO
                </span>
                <div
                  v-else-if="item.logProductionType == 'SAVE_PREPARATION_RAICE'"
                  class="text-body-2"
                >
                  <span> PREPACACÓN DE ARROZ GUARDADA </span>
                </div>
                <div
                  v-else-if="item.logProductionType == 'END_PREPARATION_RAICE'"
                  class="text-body-2"
                >
                  <span> PREPACACÓN DE ARROZ FINALIZADA </span>
                </div>
                <div
                  v-else-if="item.logProductionType == 'SAVE_INOCULATION_RAICE'"
                  class="text-body-2"
                >
                  <span> INOCULACIÓN DE ARROZ GUARDADA </span>
                </div>
                <div
                  v-else-if="item.logProductionType == 'END_INOCULATION_RAICE'"
                  class="text-body-2"
                >
                  <span> INOCULACIÓN DE ARROZ FINALIZADA </span>
                </div>
                 <div
                  v-else-if="item.logProductionType == 'FERTILIZER_END'"
                  class="text-body-2"
                >
                  <span> LOTE FINALIZADO </span>
                </div>
                <span class="text-body-2" v-else>
                  EVENTO NO RECONOCIDO {{ item.logProductionType }}</span
                >
                <v-spacer></v-spacer>
                <span class="text-caption">
                  <div v-if="item.user">
                    {{ item.user.name }} {{ item.user.lastName }}
                  </div>
                  -
                  {{ dateFormat(item.date) }}
                </span>
              </template>
            </v-data-table>
            <v-pagination
              v-model="page"
              :length="numPages"
              total-visible="10"
              color="primary"
            ></v-pagination>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row class="text-center">
          <v-col class="mt-5"
            ><span class="font-weight-bold text-subtitle-2">
              No hay un lote seleccionado
            </span>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <UpdateLoteFungiModal
      v-model="showUpdateLoteFungiModal"
      v-if="showUpdateLoteFungiModal"
    />
    <UpdateLoteBioModal
      v-model="showUpdateLoteBioModal"
      v-if="showUpdateLoteBioModal"
    />
    <UpdateLoteBacteriaModal
      v-model="showUpdateLoteBacteriaModal"
      v-if="showUpdateLoteBacteriaModal"
    />
    <update-lote-bacteria-quality-modal
      v-model="showUpdateLoteBacteriaQualityModal"
      v-if="showUpdateLoteBacteriaQualityModal"
    />
    <update-lote-fungi-quality-modal
      v-model="showUpdateLoteFungiQualityModal"
      v-if="showUpdateLoteFungiQualityModal"
    />
  </v-card>
</template>

<script>
// date library
import dayjs from "dayjs";
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
//components
import UpdateLoteFungiModal from "@/components/dashboard/lote/modals/UpdateLoteFungiModal.vue";
import UpdateLoteBioModal from "@/components/dashboard/lote/modals/UpdateLoteBioModal.vue";
import UpdateLoteBacteriaModal from "@/components/dashboard/lote/modals/UpdateLoteBacteriaModal.vue";
import UpdateLoteBacteriaQualityModal from "./modals/UpdateLoteBacteriaQualityModal.vue";
import UpdateLoteFungiQualityModal from "./modals/UpdateLoteFungiQualityModal.vue";
export default {
  components: {
    UpdateLoteFungiModal,
    UpdateLoteBioModal,
    UpdateLoteBacteriaModal,
    UpdateLoteBacteriaQualityModal,
    UpdateLoteFungiQualityModal,
  },
  data: () => ({
    headers: [
      {
        text: "Registros producción",
        align: "start",
        value: "logProductionType",
        sortable: false,
      },
    ],
    productionLogs: [],
    page: 1,
    numPages: 1,
    fetchingData: false,
    showUpdateLoteFungiModal: false,
    showUpdateLoteBioModal: false,
    showUpdateLoteBacteriaModal: false,
    showUpdateLoteBacteriaQualityModal: false,
    showUpdateLoteFungiQualityModal: false,
    user: JSON.parse(localStorage.getItem("user")),
  }),
  mounted() {},
  computed: {
    ...mapState("lotes", ["loteSelected"]),
  },
  methods: {
    ...mapActions("lotes", ["getLogs"]),
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    elapsedTime(date) {
      if (date) {
        let now = new Date();
        let update = new Date(date);
        const diffTime = Math.abs(update - now);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        var cd = 24 * 60 * 60 * 1000,
          ch = 60 * 60 * 1000,
          d = Math.floor(diffTime / cd),
          h = Math.floor((diffTime - d * cd) / ch),
          m = Math.round((diffTime - d * cd - h * ch) / 60000),
          pad = function (n) {
            return n < 10 ? "0" + n : n;
          };
        if (m === 60) {
          h++;
          m = 0;
        }
        if (h === 24) {
          d++;
          h = 0;
        }
        let template = "";
        let day = d;
        let houres = pad(h);
        let minutes = pad(m);
        let nothing = 0;
        if (day > 0) {
          if (day <= 1) {
            template += `${day} día `;
          } else {
            template += `${day} días `;
          }
        } else {
          nothing++;
        }

        if (houres > 0) {
          if (houres <= 1) {
            template += `${houres} hora `;
          } else {
            template += `${houres} horas `;
          }
        } else {
          nothing++;
        }

        if (minutes > 0) {
          if (minutes <= 1) {
            template += `${minutes} minuto`;
          } else {
            template += `${minutes} minutos`;
          }
        } else {
          nothing++;
        }

        if (nothing++ == 3) {
          template += `unos segundos`;
        }

        return template;
      } else {
        return "-";
      }
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getLogs({
          loteId: this.loteSelected._id,
          page: this.page,
        });
        if (response) {
          if (!response.error) {
            this.productionLogs = response.lotesLogs;
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar eventos en lote`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar eventos en lote`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar eventos en lote`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    openUpdateLoteModal() {
      if (this.loteSelected.loteType == "SINGLE") {
        if (
          this.loteSelected.moType == "fungi" ||
          this.loteSelected.identificationName == "Streptomyces griseoviridis"
        ) {
          this.showUpdateLoteFungiModal = true;
        } else {
          this.showUpdateLoteBacteriaModal = true;
        }
      } else if (this.loteSelected.loteType == "BIO") {
        this.showUpdateLoteBioModal = true;
      }
    },
    openUpdateLoteModalQ() {
      if (this.loteSelected.loteType == "SINGLE") {
        if (
          this.loteSelected.moType == "fungi" ||
          this.loteSelected.identificationName == "Streptomyces griseoviridis"
        ) {
          this.showUpdateLoteFungiQualityModal = true;
        } else {
          this.showUpdateLoteBacteriaQualityModal = true;
        }
      } else if (this.loteSelected.loteType == "BIO") {
        this.showUpdateLoteBioModal = true;
      }
    },
  },
  watch: {
    async loteSelected(value) {
      if (value) {
        await this.fetchData();
      }
    },
    async page() {
      if (this.loteSelected) {
        await this.fetchData();
      }
    },
  },
};
</script>

<style scoped>
.finish {
  background-color: #04c105;
  color: white;
}
.comonstate {
  background-color: #dadada;
  color: black;
}
.decrease {
  background-color: red;
  color: white;
}
.stockSpore {
  background-color: #fbc02d;
  color: white;
}
</style>
